import { useMutation } from '@tanstack/react-query';
import { API_LIST_SIGNUP } from 'lib/constants/routes';

const CREATE_LIST_SIGNUP_KEY = 'createListSignup';

interface ListSignupData {
  listId: string;
  source: string;
  email?: string;
  phoneNumber?: string;
  profileId?: string;
  emailConsent?: boolean;
  smsConsent?: boolean;
}

const FALLBACK_ERROR_MESSAGE = 'List signup failed';

const createListSignup = async ({
  listId,
  source,
  email,
  phoneNumber,
  profileId,
  emailConsent,
  smsConsent,
}: ListSignupData) => {
  const response = await fetch(API_LIST_SIGNUP, {
    method: 'post',
    body: JSON.stringify({
      listId,
      source,
      email,
      phoneNumber,
      profileId,
      emailConsent,
      smsConsent,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(FALLBACK_ERROR_MESSAGE);
  }

  return response;
};

export const useListSignup = () =>
  useMutation({
    mutationKey: [CREATE_LIST_SIGNUP_KEY],
    mutationFn: createListSignup,
  });
